import deepLinkNoAuth from './deepLinkNoAuth';
import news from './news';
import noAuth from './noAuth';
import noAuthWithJava from './noAuthWithJava';

let promoRoutes = [];

promoRoutes = promoRoutes.concat(
    deepLinkNoAuth,
    //General
    noAuth,
    //noAuth
    noAuthWithJava,
    news,
);
export default promoRoutes;
